export function filterTitleBySearchValue(data: any[], targetValue: string) {
  const filterResult = data.filter((compareItem) => {
    const { title: originValue } = compareItem;
    if (!originValue) return;
    const compareTarget = targetValue.toLowerCase().replace(/\s+/g, '');
    const compareOrigin = originValue.toLowerCase().replace(/\s+/g, '');
    return compareOrigin.includes(compareTarget);
  });
  return filterResult;
}

export function filteIdBySearchList(data: any[], targetValue: string) {
  const filterResult = data.filter((compareItem) => {
    const { title: originValue } = compareItem;
    if (!originValue) return;
    const compareTarget = targetValue.toLowerCase().replace(/\s+/g, '');
    const compareOrigin = originValue.toLowerCase().replace(/\s+/g, '');
    return compareOrigin.includes(compareTarget);
  });
  return filterResult;
}

export function filterUserBySearchValue(data: any[], targetValue: string) {
  const filterResult = data.filter((compareItem) => {
    // 1. targetValue값을 userID로 변환
    // 2. participants (userIds)에서 해당 userId가 있는지 검색
    const { participants } = compareItem;
    if (!participants || participants.length === 0) return;
    return participants.includes(targetValue);
  });
  return filterResult;
}
